import React, { ComponentProps, FC } from "react";
import { Text } from "./text";

type StitchesLabelledInputProps = ComponentProps<"div">;

export interface LabelledInputProps extends StitchesLabelledInputProps {
  label?: string;
  extra?: string;
  name: string;
  error?: string;
}

// TODO : Add a custom input for submit etc. Only valid for type='text' for now
export const LabelledInput: FC<LabelledInputProps> = ({ label, extra, children, name, error, ...props }) => (
  <div style={{ padding: "0.75rem 0", textAlign: "left" }} {...props}>
    <div
      style={{
        display: "flex",
        paddingBottom: "0.375rem",
        width: "100%",
        alignItems: "center",
      }}
    >
      <label htmlFor={name} style={{ flex: 1, marginRight: "1rem" }}>
        <Text>{label}</Text>
        <Text isExtra>{extra}</Text>
      </label>
      {children}
    </div>
    {error && <Text isError>{error}</Text>}
  </div>
);
